export const formatGrade = (grade: number): string => {
  if (grade === 0) return "";
  return grade % 1 === 0 ? grade.toString() : grade.toFixed(2);
};
